import React from 'react'
import './services.css'
function Services() {
 
    const customStyles = {
      fontSize: '16px',
      height:'500px',
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
     
    };
  
  return (
    <div className='services-container mb-5 mt-5'>
    <h3 className='mb-5'>TJÄNSTER</h3>
    <div className='row class-row  mx-auto'>
      {/* one */}
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-2" ></div>
  <div className="card-body overflow-auto">
  <h5>Inskription på gravsten.</h5>
    <p className="card-text ">  En textkomplettering av en sten gör man när det redan finns en befintlig gravsten som man vill lägga till mer text på. Det kan till exempel vara ett nytt namn eller ett årtal som fattas. Vi går till din sten och lägger till ny text.</p>
  </div>
  <div> 4.500 kr Fast pris upp till 40 tecken. Vid över 40 tecken tillkommer 100 kr/ tecken.</div>
</div>
      </div>
          {/* one */}
    {/* one */}
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3 '>
      <div className="card pb-3" style={customStyles}>
   <div className="card-img-top card-1" ></div>
  <div className="card-body overflow-auto">
  <h5>Gravering  av naturstenar. </h5>
    <p className="card-text">En annan typ av gravsten som blir allt vanligare är naturstenar där man graverar in personens namn och årtal. Då kan du till exempel välja din sten, kanske från dacha eller någon annan plats.</p>
  </div>
  <div>4.500 kr Fast pris upp till 40 tecken. Vid över 40 tecken tillkommer 100 kr/ tecken</div>
</div>
      </div>
        {/* one */}
        <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-6" ></div>
  <div class="card-body ">
  <h5>Rengörning av gravsten</h5>
    <p className="card-text"> </p>
  </div>
  <div>Pris förhandlingsbart</div>
</div>
      </div>
      {/* one */}
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-4" ></div>
  <div className="card-body">
  <h5> Förgyllning av text</h5>
    <p className="card-text"> </p>
  </div>
  <div>95 kr / tecken</div>
</div>
    </div>
       
     
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-5" ></div>
  <div class="card-body">
  <h5>Ommålning av text</h5>
    <p className="card-text"> </p>
  </div>
  <div>50 kr / tecken</div>
</div>
      </div>
          {/* one */}
      {/* one */}
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-3" ></div>
  <div className="card-body overflow-auto">
  <h5>Hantverksgraveringar.</h5>
    <p className="card-text">  Vi utför hantverksgraveringar såsom porträtt av den avlidne,  olika natur- och djurmotiv. Allt som våra kunder vill ha. Detta arbete utförs endast på svart granit. </p>
  </div>
  <div>Pris förhandlingsbart</div>
</div>
      </div>
          {/* one */}
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-7" ></div>
  <div class="card-body overflow-auto">
  <h5>Fixa en lutad sten</h5>
    <p className="card-text "> För att klara säkerhetskraven på kyrkogården så kan en gravsten som lutar behöva säkras. För att vara godkänd så ska alla gravstenar högre är 30 cm klara ett sidotryck på minst 35 kg.Vi säkrar stenen med   markdubbsmetoden riktar vi även upp stenen så att den står rakt. </p>
  </div>
  <div>Pris förhandlingsbart</div>
</div>
      </div>
      <div className='col-sm-12 col-md-5 col-lg-3 mb-3'>
        <div className="card pb-3" style={customStyles}>
        <div className="card-img-top card-8" ></div>
  <div className="card-body">
  <h5> Övriga renoveringar</h5>
    <p className="card-text"></p>
  </div>
</div>    </div> </div>
    </div>
  )
}

export default Services